/* LSL · Fiche produit, mise en page C (suite de lsl-cb.js et lsl-cb2.js).
   - Offre : la fenêtre « Détails de l'offre » est sortie du bloc masqué qui la contenait (sinon la page se figeait à l'ouverture).
   - Choix de version : chaque version a sa carte (filet de lumière qui s'allume, nom, usage, prix), puis une fiche « Pourquoi choisir… ». Les vrais boutons radio du thème restent.
     « Poignée vide (sans électronique) » a aussi sa carte : filet acier qui ne s'allume pas (rien à allumer).
   - « Comparer les versions » : ouvre la fenêtre de snippets/lsl-cb-cmpdlg.liquid à la place de l'ancienne.
   - Sabres de combat : l'offre Kaching (paliers -10 / -20 / -25 %) habillée comme la carte « Ton offre du moment ».
   - Code promo en plus (ligne 3 de l'offre dans Paramètres du thème : étiquette = code) : ligne « code à copier » dans les cartes d'offre, jusqu'à la date de fin de l'offre.
   - Mobile : texte du bouton d'achat sur une seule ligne.
   - Avis : onglets « Avis sur ce sabre » (bloc Ali Reviews du produit, déplacé ici) et « Photos et vidéos de nos clients ». */
(() => {
  'use strict';
  const root = document.querySelector('[data-lsl-cb]');
  if (!root) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const sec = $('.shopify-section--main-product') || document;
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const data = $('#lsl-pc-data');

  /* ---------- Date de fin de l'offre (même lecture que lsl-cb2.js ; aperçu : ?lsl_now=2026-12-03) ---------- */
  const OFF = (() => { const p = new URLSearchParams(location.search).get('lsl_now'); const t = p ? Date.parse(p + (p.length <= 10 ? 'T12:00:00' : '')) : NaN; return isNaN(t) ? 0 : t - Date.now(); })();
  const nowMs = () => Date.now() + OFF;
  const MONTHS = ['janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'decembre'];
  const offerEnd = (() => {
    const txt = ((data && data.dataset.offer) || '').split(' · ').slice(1).join(' · ');
    const m = txt.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').match(/(\d{1,2})(?:er)?\s+(janvier|fevrier|mars|avril|mai|juin|juillet|aout|septembre|octobre|novembre|decembre)/);
    if (!m) return null;
    const now = nowMs(), y = new Date(now).getFullYear(), mi = MONTHS.indexOf(m[2]);
    return [y - 1, y, y + 1].map(yy => new Date(yy, mi, +m[1], 23, 59, 59)).sort((a, b) => Math.abs(a - now) - Math.abs(b - now))[0];
  })();

  /* ---------- Fenêtre de l'offre : hors du bloc masqué ---------- */
  /* Le thème ré-affiche le bloc d'achat quand la version change : une nouvelle fenêtre réapparaît alors dans le bloc masqué, on la ressort et on retire l'ancienne. */
  function offerDialog() {
    const all = $$('[id="lsl-po-dlg"]');
    const fresh = all.find(d => d.parentElement !== document.body);
    if (!fresh) return;
    all.forEach(d => { if (d !== fresh && !d.open) d.remove(); });
    document.body.append(fresh);
  }

  /* ---------- Couleur de lame du produit (celle du simulateur) ---------- */
  const beam = () => { const s = $('.lsl-sim[data-mq-sim]', root); return (s && s.style.getPropertyValue('--beam').trim()) || '#4FA8FF'; };

  /* ---------- Choix de version ---------- */
  const VX = {
    rgb: { n: 'RGB', tag: 'Combat', sub: 'Lumière dans la poignée · 16 sons' },
    neo: { n: 'NeoPixel', tag: 'Immersion', sub: 'LEDs dans toute la lame · 27 sons' },
    proffie: { n: 'Proffie', tag: 'Personnalisation', sub: 'Programmable · 25 effets de lame' },
    empty: { n: 'Poignée vide', tag: 'Collection', sub: 'Sans électronique' }
  };
  const INFO = {
    rgb: { stats: [['12 W', 'LED dans la poignée'], ['16', 'sons'], ['12', 'couleurs']], ideal: ['Combat', 'Entraînement', 'Premier sabre'], body: 'Pour le combat et l’entraînement : une lame éclairée depuis la poignée, solide et simple à utiliser.' },
    neo: { stats: [['50 W', 'LEDs dans la lame'], ['27', 'profils sonores'], ['9', 'effets de lame']], ideal: ['Cosplay', 'Collection', 'Effet waouh'], body: 'Pour un rendu spectaculaire : des LEDs dans toute la lame, une lumière intense et un allumage progressif.' },
    proffie: { stats: [['50 W', 'LEDs dans la lame'], ['25', 'sons modifiables'], ['25', 'effets programmables']], ideal: ['Personnalisation', 'Passionnés'], body: 'Pour aller plus loin : une lame NeoPixel pilotée par une carte Proffie que tu programmes à ton goût.' },
    empty: { stats: [], ideal: ['Collection', 'Exposition'], body: 'La réplique du manche seule, sans électronique : une pièce à exposer ou à collectionner.' }
  };
  const keyOf = t => /poign[ée]e\s+vide|sans\s+(?:kit\s+)?[ée]lectronique|empty/i.test(t) ? 'empty' : /proffie/i.test(t) ? 'proffie' : /neo/i.test(t) ? 'neo' : /rgb/i.test(t) ? 'rgb' : '';
  function vx() {
    const fs = $('.lsl-version-selector', sec); if (!fs) return;
    const c = beam();
    if (fs.style.getPropertyValue('--lsl-beam') !== c) fs.style.setProperty('--lsl-beam', c);
    fs.classList.add('lsl-vx-on');
    $$('label.block-swatch', fs).forEach(l => {
      const nameEl = Array.from(l.children).find(x => x.tagName === 'SPAN' && !x.className);
      const raw = ((nameEl || l).textContent || '').replace(/\s+/g, ' ').trim();
      const k = keyOf(raw);
      if (!k) return;
      if (l.dataset.vx === k && l.dataset.vxRaw === raw && $('.lsl-vx__head', l)) return;
      l.dataset.vx = k; l.dataset.vxRaw = raw; l.classList.add('lsl-vx');
      $$('.lsl-vx__saber, .lsl-vx__head, .lsl-vx__sub', l).forEach(x => x.remove());
      const d = VX[k], tg = $('.lsl-pd-vtag', l);
      /* « RGB Lame 58 cm (enfant) » : le détail de la version remplace la description générique */
      const extra = raw.replace(/proffie|neo\s?pixel|rgb|poign[ée]e\s+vide/ig, '').replace(/^[\s·\-–—:|,]+|[\s·\-–—:|,]+$/g, '').replace(/^\((.*)\)$/, '$1').trim();
      const sub = extra ? extra.charAt(0).toUpperCase() + (k === 'empty' ? extra.slice(1).toLowerCase() : extra.slice(1)) : d.sub;
      l.insertAdjacentHTML('afterbegin',
        `<span class="lsl-vx__head"><b class="lsl-vx__name">${d.n}</b><em class="lsl-vx__tag">${esc((tg && tg.textContent.trim()) || d.tag)}</em></span>` +
        `<span class="lsl-vx__sub">${esc(sub)}</span>`);
    });
    vinfo(fs);
  }

  /* Fiche « Pourquoi choisir… » de la version choisie (remplace l'aide du thème, son texte est repris) */
  function vinfo(fs) {
    const i = $('input[type="radio"]:checked', fs);
    const l = i && ((i.labels && i.labels[0]) || fs.querySelector(`label[for="${i.id}"]`));
    const k = l && l.dataset.vx;
    let box = $('.lsl-vxi', fs);
    if (!k) { if (box) box.hidden = true; return; }
    const help = $(`.lsl-version-help[data-lsl-value="${i.value}"]`, fs);
    const ht = help && $('.lsl-version-help__title', help), hb = help && $('.lsl-version-help__body', help);
    const d = INFO[k], name = VX[k].n;
    const title = (ht && ht.textContent.trim()) || (k === 'empty' ? 'Pourquoi choisir la poignée vide ?' : `Pourquoi choisir le ${name} ?`);
    const body = (hb && hb.textContent.trim()) || d.body;
    const html = `<p class="lsl-vxi__t">${esc(title)}</p><p class="lsl-vxi__p">${esc(body)}</p>` +
      (d.stats.length ? `<dl class="lsl-vxi__stats">${d.stats.map(s => `<div><dt>${esc(s[1])}</dt><dd>${esc(s[0])}</dd></div>`).join('')}</dl>` : '') +
      `<p class="lsl-vxi__ideal"><span>Idéal pour</span>${d.ideal.map(x => `<em>${esc(x)}</em>`).join('')}</p>`;
    if (!box) {
      box = document.createElement('div');
      box.className = 'lsl-vxi';
      box.setAttribute('aria-live', 'polite');
      const list = $('.lsl-version-help-list', fs);
      if (list) list.before(box); else fs.append(box);
    }
    box.hidden = false;
    if (box.dataset.k !== k + i.value) { box.dataset.k = k + i.value; box.dataset.kind = k; box.innerHTML = html; }
  }

  /* ---------- Code promo en plus ---------- */
  const code = (() => {
    const c = ((data && data.dataset.code) || '').trim();
    if (!/^[A-Z0-9][A-Z0-9_-]{2,}$/.test(c)) return null;
    if (offerEnd && nowMs() > offerEnd) return null;
    return { c, t: ((data && data.dataset.codeT) || '').trim() || 'En plus sur toute ta commande avec le code' };
  })();
  const codeHtml = () => `<div class="lsl-code"><span class="lsl-code__t">${esc(code.t)}</span><button type="button" class="lsl-code__c" data-lsl-code="${esc(code.c)}" aria-label="Copier le code ${esc(code.c)}">${esc(code.c)}<i>Copier</i></button></div>`;
  function codeInto(host, first) {
    if (!code || !host || $('.lsl-code', host)) return;
    host.insertAdjacentHTML(first ? 'afterbegin' : 'beforeend', codeHtml());
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-lsl-code]'); if (!b) return;
    const v = b.dataset.lslCode, i = $('i', b);
    const ok = () => { if (i) { i.textContent = 'Copié ✓'; setTimeout(() => { i.textContent = 'Copier'; }, 1800); } };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(ok, ok); else ok();
  });

  /* ---------- Offres : carte des cadeaux (répliques) et carte combat (paliers Kaching) ---------- */
  function offers() {
    const pi = $('.product-info', sec); if (!pi) return;
    /* Répliques : la carte « Ton offre du moment » (lsl-cb2.js) reçoit la ligne du code */
    if (pi.classList.contains('lsl-of-on')) {
      /* la carte des cadeaux est arrivée après coup : on retire la carte combat posée trop tôt */
      if (pi.classList.contains('lsl-cof-on')) { pi.classList.remove('lsl-cof-on'); $$('.lsl-cof, .lsl-cof__foot', pi).forEach(x => x.remove()); }
      codeInto($('.lsl-pc-ofoot', pi), true);
      return;
    }
    const blk = $('.kaching-bundles__block', pi), bars = blk && $('.kaching-bundles__bars', blk);
    if (!bars || $('.lsl-pc-ohead', pi) || bars.classList.contains('lsl-of-single')) return;
    /* La carte se pose autour du bloc Kaching, sans toucher à son contenu (géré par l'appli) */
    const host = blk.closest('kaching-bundle') || blk.closest('kaching-bundles-block') || blk;
    /* seulement des paliers en % (sabres de combat) */
    const pcs = $$('.kaching-bundles__bar-label', bars).map(x => parseInt((x.textContent.match(/(\d+)\s*%/) || [])[1] || '0', 10));
    const max = Math.max(0, ...pcs);
    if (!max || $$('.kaching-bundles__bar', bars).length < 2) return;
    pi.classList.add('lsl-cof-on');
    const t0 = (($('.kaching-bundles__block-title', blk) || {}).textContent || '').trim();
    const name = /combat/i.test(t0) ? 'Offre combat' : (t0 ? t0.charAt(0).toUpperCase() + t0.slice(1).toLowerCase() : 'Offre du moment');
    const html = `<b class="lsl-of__h">Ton offre du moment</b><div class="lsl-cof__card"><span class="lsl-of__pill">${esc(name)}${max ? ' · jusqu’à -' + max + ' %' : ''}</span><p class="lsl-cof__p">Plus tu prends de sabres, moins tu paies. La remise s’applique toute seule au panier.</p></div>`;
    let head = $('.lsl-cof', pi);
    if (!head) { head = document.createElement('div'); head.className = 'lsl-cof'; }
    if (head.nextElementSibling !== host) host.before(head);
    if (head.dataset.h !== html) { head.dataset.h = html; head.innerHTML = html; }
    let foot = $('.lsl-cof__foot', pi);
    if (!foot) { foot = document.createElement('div'); foot.className = 'lsl-cof__foot'; foot.innerHTML = '<p class="lsl-cof__note">Remise appliquée automatiquement · livraison standard offerte</p>'; }
    if (host.nextElementSibling !== foot) host.after(foot);
    /* Le bloc Kaching est « à plat » dans la grille : la carte prend la place de la liste des paliers */
    const ord = getComputedStyle(bars).order;
    if (head.style.order !== ord) head.style.order = ord;
    if (foot.style.order !== ord) foot.style.order = ord;
    codeInto(foot, true);
  }

  /* ---------- Mobile : texte du bouton d'achat sur une ligne ---------- */
  function fitBuy() {
    const d = $('.product-info .buy-buttons button[type="submit"] [data-lsl-total]', sec); if (!d) return;
    if (!matchMedia('(max-width: 699px)').matches) { if (d.style.fontSize) d.style.removeProperty('font-size'); return; }
    /* la taille du thème est en !important : la nôtre aussi */
    let s = 14; const set = () => d.style.setProperty('font-size', s + 'px', 'important');
    set();
    while (d.scrollWidth > d.clientWidth + 1 && s > 10) { s -= 0.5; set(); }
  }

  /* ---------- Fenêtre « Comparer les versions » ---------- */
  function compare() {
    const d = document.getElementById('lsl-cmpd'); if (!d) return;
    const lit = () => {
      d.classList.remove('is-lit');
      void d.offsetWidth;
      requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-lit')));
    };
    const open = () => {
      d.style.setProperty('--lsl-beam', beam());
      if (!d.open) d.showModal();
      d.scrollTop = 0;
      if (reduce()) d.classList.add('is-lit'); else lit();
    };
    window.openVersionPopup = open; /* l'ancienne fenêtre n'est plus utilisée */
    document.addEventListener('click', e => {
      const b = e.target.closest('.lsl-pd-compare, [data-lsl-cmpd-open]');
      if (b) { e.preventDefault(); e.stopImmediatePropagation(); open(); return; }
      if (e.target.closest('[data-lsl-cmpd-replay]')) lit();
    }, true);
    d.addEventListener('close', () => d.classList.remove('is-lit'));
  }

  /* ---------- Avis : onglets ---------- */
  function reviewTabs() {
    const bar = $('[data-lsl-rt]', root); if (!bar) return;
    const box = $('.alireviews-review-box', sec);
    const app = box && (box.closest('.shopify-block') || box);
    if (!app || !(parseInt(bar.dataset.count || '0', 10) > 0)) return;
    const pa = $('[data-lsl-rt-panel="ali"]', root), ps = $('[data-lsl-rt-panel="shop"]', root);
    const item = app.closest('.product-info__block-item');
    pa.append(app);
    if (item) item.classList.add('lsl-cb-gone');
    root.classList.add('lsl-rt-on');
    bar.hidden = false;
    const tabs = $$('[data-lsl-rt-tab]', bar);
    const show = (w, focus) => {
      tabs.forEach(t => { const on = t.dataset.lslRtTab === w; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
      pa.hidden = w !== 'ali';
      if (ps) ps.hidden = w !== 'shop';
      if (w === 'ali') dispatchEvent(new Event('resize')); /* le carrousel Ali se recale à sa nouvelle largeur */
    };
    bar.addEventListener('click', e => { const t = e.target.closest('[data-lsl-rt-tab]'); if (t) show(t.dataset.lslRtTab); });
    bar.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const i = tabs.findIndex(t => t.getAttribute('aria-selected') === 'true');
      const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      show(n.dataset.lslRtTab, true); e.preventDefault();
    });
    show('ali');
    /* 03/11 : Ali Reviews charge ses photos quand elles arrivent à l'écran ; une fois son bloc déplacé dans l'onglet, ce chargement rate
       la plupart d'entre elles (cases blanches). On met nous-mêmes l'adresse, rangée par Ali dans l'attribut alt, au même format que les siennes. */
    const fill = () => pa.querySelectorAll('.alr-wh-comp-image-lazy-load img:not([src])').forEach(i => {
      const u = i.getAttribute('alt') || ''; if (!/^https?:\/\//.test(u)) return;
      i.addEventListener('load', () => { i.style.opacity = '1'; }, { once: true });
      i.loading = 'lazy'; i.src = 'https://imgs.alireviews.io/images/resize?url=' + u + '&width=300';
    });
    let ft = 0;
    new MutationObserver(() => { clearTimeout(ft); ft = setTimeout(fill, 150); }).observe(pa, { childList: true, subtree: true });
    fill();
    /* La note sous le titre mène aux avis du produit */
    document.addEventListener('click', e => {
      const r = e.target.closest('.product-info .alireviews-review-star-rating');
      if (!r) return;
      e.preventDefault(); e.stopImmediatePropagation();
      show('ali');
      const a = document.getElementById('avis');
      if (a) a.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
    }, true);
    /* Nombre d'avis de la boutique dans le 2e onglet */
    const n = $('[data-lsl-rt-n]', bar);
    const count = () => { const c = ps ? $$('[data-review-card]', ps).length : 0; if (n) { n.textContent = c ? String(c) : ''; n.hidden = !c; } };
    count(); setTimeout(count, 1200);
  }

  const all = () => { offerDialog(); vx(); offers(); fitBuy(); };
  const run = () => {
    all();
    compare();
    reviewTabs();
    /* Le bloc d'achat peut être remplacé en entier (changement de version, Kaching) : on surveille la section, hors du bas de fiche */
    if (sec !== document) {
      let t = 0;
      new MutationObserver(ms => {
        if (!ms.some(m => !root.contains(m.target))) return;
        /* tout de suite, avant l'affichage : sinon l'ancienne carte de version (et l'ancienne offre) réapparaît un instant après chaque changement */
        vx(); offers();
        clearTimeout(t); t = setTimeout(all, 60);
      }).observe(sec, { subtree: true, childList: true, characterData: true });
    }
    document.addEventListener('click', e => { if (e.target.closest('[data-lsl-po-open]')) offerDialog(); }, true);
    document.addEventListener('change', () => setTimeout(all, 80));
    addEventListener('resize', fitBuy);
    [800, 1500, 3000].forEach(ms => setTimeout(all, ms));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
